import { getCountries, getExampleNumber } from "libphonenumber-js";
import examples from "libphonenumber-js/examples.mobile.json";

import type { CountryInputInfo, CountryCodeWithOther } from "./types";

export const brazilPhoneInfo: {
    countryCode: Extract<CountryCodeWithOther, "BR">;
    masks: {
        international: string[];
        national: string[];
    };
    regex: string;
    placeholder: {
        international: string;
        national: string;
    };
} = {
    countryCode: "BR",
    masks: {
        international: ["+99 (99) 9999-9999", "+99 (99) 99999-9999"],
        national: ["(99) 9999-9999", "(99) 99999-9999"]
    },
    regex: "",
    placeholder: {
        international: "+55 (00) 00000-0000",
        national: "(00) 00000-0000"
    }
};

export const getCountryInputInfo = () => {
    const countryInputInfo: Record<string, { mask: string | string[]; regex: string; placeholder: string }> = {
        other: {
            mask: "",
            regex: "\\+?[1-9]\\d{0,3}(?:[\\s\\-]?\\d{1,4}){1,4}",
            placeholder: "+000000000000000"
        }
    };

    getCountries().forEach((country) => {
        const example = getExampleNumber(country, examples);
        if (!example) return;

        let placeholder = example.formatInternational();
        let mask: string | string[] = placeholder.replace(/\d/g, "9");

        if (country === brazilPhoneInfo.countryCode) {
            mask = brazilPhoneInfo.masks.international;
            placeholder = brazilPhoneInfo.placeholder.international;
        }

        countryInputInfo[country] = {
            mask: mask,
            placeholder: placeholder,
            regex: ""
        };
    });

    return countryInputInfo as CountryInputInfo;
};
